import  { useEffect, useState } from "react";
import axios from "axios";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  Tooltip,
  Legend,
  LinearScale,
  CategoryScale,
  LineElement,
  PointElement,
} from "chart.js";
import { CircularProgress, Container, Typography, Box } from "@mui/material";
import config from "../../config.js";

ChartJS.register(
  Tooltip,
  Legend,
  LinearScale,
  CategoryScale,
  LineElement,
  PointElement
);

const QuantityChart = () => {
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });
  const [error, setError] = useState(null);
  const { API_BASE_URL } = config;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/v1/inventoryJson`);
        

        if (response.data && response.data.data) {
          const rawData = response.data.data.Data;
         

          if (Array.isArray(rawData)) {
            const labels = rawData.map((item) => item["Product Description"]);
            const minQuantities = rawData.map((item) => item["MIN Qty"]);
            const currentStocks = rawData.map((item) => item["Current Stock"]);

            const dataset = {
              label: "Minimum Quantity vs Current Stock",
              data: currentStocks,
              fill: false,
              borderColor: "rgba(75, 192, 192, 0.6)",
              tension: 0.1,
            };

            const minQuantityDataset = {
              label: "Minimum Quantity",
              data: minQuantities,
              fill: false,
              borderColor: "rgba(255, 99, 132, 0.6)",
              tension: 0.1,
            };

            setChartData({
              labels: labels,
              datasets: [dataset, minQuantityDataset],
            });
          } else {
            throw new Error("Data is not in expected array format.");
          }
        } else {
          throw new Error("Response does not contain expected Data property.");
        }
      } catch (error) {
        console.error("Error fetching or processing data:", error);
        setError(error);
      }
    };

    fetchData();
  }, [API_BASE_URL]);

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!chartData.labels.length) {
    return (
      <Container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Container>
    );
  } else {
    const options = {
      responsive: true,
      plugins: {
        legend: {
          display: true,
          labels: {
            color: "black",
            font: {
              size: 14,
            },
          },
        },
      },
      scales: {
        x: {
          display: true,
          title: {
            display: true,
            text: "Product",
          },
        },
        y: {
          display: true,
          title: {
            display: true,
            text: "Quantity",
          },
        },
      },
      interaction: {
        mode: "nearest",
        intersect: false,
        axis: "x",
      },
    };

    return (
      <div>
        <Box sx={{ backgroundColor: "#FF4D4D", padding: 2, borderRadius: 1 }}>
          <Typography variant="h5" sx={{ color: "#fff", textAlign: "center" }}>
            Minimum Quantity vs Current Stock
          </Typography>
        </Box>
        <Container>
          <div style={{ padding: "20px", width: "100%", height: "80%" }}>
            <Line data={chartData} options={options} />
          </div>
        </Container>
      </div>
    );
  }
};

export default QuantityChart;
